import React from 'react'
import { Grid, Paper, useTheme } from '@mui/material'
import { usage_type } from '../wsclient/crmservices/dataUtil'
import { cache } from '../utils/cache';
import { getLogoImage } from '../utils/common';
import AlertComponent from '../components/Alert';
import LoadingComponent from '../components/Loading';
import PropTypes from "prop-types";
import ConfirmComponent from '../components/Confirm';

function PublicPage(props) {
    const { children, message, showProcessing, confirm } = props;
    const appConfig = cache.getAppConfig();
    let logoImage = getLogoImage();
    const { palette } = useTheme();
    let backgroundImg = appConfig && appConfig.creatives ? getImageBackground(appConfig.creatives, usage_type.landing_page_bg) : null;
    let landingPageColor = appConfig && appConfig.appearance && appConfig.appearance.colours ? getLandingPageBackground(appConfig.appearance.colours) : null;
    
    let cssBackgroundImage = {};
    let landingPageColorGradient = landingPageColor+"4D";
    if(backgroundImg && backgroundImg.url){
        cssBackgroundImage = {
            backgroundImage: 'url(' + backgroundImg.url + ')',
            background: '-webkit-image-set( url(' + backgroundImg.url + ') 1x, url(' + backgroundImg.url + ') 2x )',
            minHeight: '100vh',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            alignItems: 'center'
        }
    } else {
        cssBackgroundImage = {
            backgroundImage: "linear-gradient("+landingPageColorGradient+", "+landingPageColor+")",
            alignItems: 'center',
            minHeight: '100vh',
        }
    }
    return (
        <Grid item xs={12} container justifyContent={'center'} style={cssBackgroundImage}>
            <Grid item xs={12} container justifyContent={'center'} paddingY={3} paddingX={3}>
                <Grid item xs={12} md={8} lg={4} component={Paper} borderRadius={4} padding={3} minHeight={'60vh'} marginBottom={7} position={'relative'}>
                    {logoImage && <Grid item xs={12} container justifyContent={'center'}>
                        <img src={logoImage} alt={'Logo Image'} height={100} />
                    </Grid>}
                    {children}
                </Grid>
            </Grid>
            {message && message.show && <AlertComponent
                isOpen={message.show}
                message={message.content}
                otherMessage={message.otherMessage ? message.otherMessage : null}
                onClose={message.callBackFn}
            />}
            {showProcessing && <LoadingComponent showLoading={showProcessing} />}
            {confirm && confirm.show && <ConfirmComponent 
                isOpen={confirm.show}
                message={confirm.message}
                actionTitle={confirm.actionTitle}
                closeTitle={confirm.closeTitle}
                onClose={confirm.onClose}
                onAction={confirm.onAction}
            />}
        </Grid>
    )
}

function getImageBackground(creatives, type){
    let image = {};
    if(creatives && creatives.length > 0){
        let landingPageImage = creatives.filter(x => x.usage_type && x.usage_type.toLowerCase() === type.toLowerCase());
        if(landingPageImage && landingPageImage.length > 0){
            image = landingPageImage[0];
        }
    }
    return image;
}

function getLandingPageBackground(colours){
    let color = null;
    let exLandingPageBg = colours.filter(x => x.type == "LANDING_BACKGROUND");
    if(exLandingPageBg && exLandingPageBg.length > 0){
        color = exLandingPageBg[0].value;
    }
    return color;
}

PublicPage.propTypes = {
    message: PropTypes.object,
    showProcessing: PropTypes.bool,
    confirm: PropTypes.object,
}

export default PublicPage;